import axios from 'axios';
import { serverConfig } from './server-config';

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      // Auth token has expired or is invalid, delete it from local storage
      localStorage.removeItem('authToken');
      location.reload();
    }
    return Promise.reject(error);
  }
);

export const BlandService = {
  initiateCall: async (candidateId) => {
    return axios.post(`https://${serverConfig.serverBaseAddress}/signite/bland/initiate-call?candidateId=${candidateId}`, {}, {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('authToken'),
      },
    });
  },
  getCallStatus: async (candidateId) => {
    return axios.get(`https://${serverConfig.serverBaseAddress}/signite/bland/call/get?candidateId=${candidateId}`, {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('authToken'),
      },
    });
  },
  getCallRecording: (recordingPath) => {
    return axios({
      method: 'get',
      url: `https://${serverConfig.serverBaseAddress}/signite/file/download?path=${recordingPath}`,
      responseType: 'blob',
      headers: {
        Authorization: `Bearer ${localStorage.getItem('authToken')}`,
      },
    });
  },
};
